



export class WhoAmIVM {
    
    isBusinessUser?: boolean;
    
    organisationNo?: string;
    
    organisation?: string;
    
    organisationImage?: string;
    
    username?: string;
    
    firstname?: string;
    
    lastname?: string;
    
    profileImage?: string;
    
    mbNumber?: string;
    
    approved?: boolean;
    
    profileComplete?: number;
    
}
